import { CurrencyCode } from 'utils/currency/getCurrencyCodes'
import { Dictionary } from 'utils/utiltyTypes/utilityTypes'
import { CoreDataCurrency } from '../currency/hooks/useOrganisationCurrencies'

type Input = {
  currenciesByCode?: Dictionary<CoreDataCurrency>
  defaultCurrency?: CurrencyCode
}

export const getDefaultFxRate = ({ currenciesByCode, defaultCurrency }: Input): number =>
  currenciesByCode && defaultCurrency ? 1 / (currenciesByCode[defaultCurrency]?.fxRate ?? 1) : 1
